import { PropsWithChildren, useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import Footer from "@/components/Footer";
import { GuideButton } from "@/components/GuideModal";
import Header from "@/components/Header";
import MenuModal from "@/components/Modal/MenuModal";
import NameConfirmModal from "@/components/Modal/NameConfirmModal";
import Toast from "@/components/Toast";
import { pageTitle } from "@/constants/common";
import useLoginCheck from "@/hooks/useLoginCheck";
import useModal from "@/hooks/useModal";
import useLoginStore from "@/store/loginStore";
import useUserStore from "@/store/userStore";

const Layout = ({ children }: PropsWithChildren) => {
  const { kakaoToken } = useLoginStore();
  useLoginCheck(kakaoToken);
  const location = useLocation();
  const pageName = location.pathname.split("/")[1];
  const mainTitle = pageTitle[pageName].mainTitle;
  const subTitle = pageTitle[pageName].subTitle;
  const guide = pageTitle[pageName].guide;

  const menuModal = useModal();
  const { nameConfirmed, userName } = useUserStore();
  const [showNameConfirm, setShowNameConfirm] = useState(false);

  useEffect(() => {
    if (userName && nameConfirmed !== "Y") {
      setShowNameConfirm(true);
    }
  }, [userName, nameConfirmed]);

  return (
    <div className="relative flex min-h-screen min-w-80 flex-col bg-gray-50">
      <Header onOpen={menuModal.onOpen} />
      <main className="flex-1 px-4 pb-8 pt-6 sm:px-6 md:px-8 lg:px-10 xl:px-12">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <h1 className="text-small font-medium tracking-wide text-primary/70">{mainTitle}</h1>
            <h2 className="text-2xl font-bold text-black">{subTitle}</h2>
          </div>
          {guide && <GuideButton title={`${subTitle} 안내`} content={guide} />}
        </div>
        {children}
      </main>
      <Footer />
      {menuModal.isOpen && <MenuModal onClose={menuModal.onClose} />}
      {showNameConfirm && (
        <NameConfirmModal onClose={() => setShowNameConfirm(false)} />
      )}
      <Toast />
    </div>
  );
};

export default Layout;
